export default __webpack_public_path__ + "static/media/blankImage.c3f94521.png";